import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';
import { companyInfo } from '../utils/mockData';

export const Footer = () => {
  const productLinks = [
    'Elektrikli Ev Aletleri',
    'Ev Tekstil',
    'Otomotiv',
    'Gıda',
    'Oyuncak',
    'Pet Food'
  ];

  const quickLinks = [
    { name: 'Hakkımızda', path: '/hakkimizda' },
    { name: 'Ürünler', path: '/urunler' },
    { name: 'Üretim Süreçleri', path: '/uretim-surecleri' },
    { name: 'Sertifikalar', path: '/sertifikalar' },
    { name: 'İletişim', path: '/iletisim' }
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-gray-300">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <Link to="/" className="inline-block mb-6 group">
              <img 
                src={companyInfo.logo}
                alt={companyInfo.name}
                className="h-12 w-auto object-contain brightness-0 invert transition-transform group-hover:scale-110"
              />
            </Link>
            <p className="text-sm text-gray-400 mb-6">
              Sürdürülebilir ambalaj çözümlerinde 20 yıllık tecrübe ile sektörün lider firması.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-lime-600 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-lime-600 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-lime-600 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-lime-600 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-6">Hızlı Erişim</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="text-gray-400 hover:text-lime-500 transition-colors flex items-center group"
                  >
                    <span className="w-0 h-0.5 bg-lime-500 group-hover:w-4 transition-all mr-0 group-hover:mr-2"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-6">Ürün Kategorileri</h4>
            <ul className="space-y-3">
              {productLinks.map((product) => (
                <li key={product}>
                  <Link 
                    to="/urunler" 
                    className="text-gray-400 hover:text-lime-500 transition-colors flex items-center group"
                  >
                    <span className="w-0 h-0.5 bg-lime-500 group-hover:w-4 transition-all mr-0 group-hover:mr-2"></span>
                    {product}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-6">İletişim</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-lime-500 mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-400">{companyInfo.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-lime-500 flex-shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="text-sm text-gray-400 hover:text-lime-500 transition-colors">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-lime-500 flex-shrink-0" />
                <div className="flex flex-col">
                  <a href={`mailto:${companyInfo.email}`} className="text-sm text-gray-400 hover:text-lime-500 transition-colors">
                    {companyInfo.email}
                  </a>
                  <a href={`mailto:${companyInfo.salesEmail}`} className="text-sm text-gray-400 hover:text-lime-500 transition-colors">
                    {companyInfo.salesEmail}
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-500">
              © {new Date().getFullYear()} {companyInfo.name}. Tüm hakları saklıdır.
            </p>
            <div className="flex space-x-6">
              <Link to="#" className="text-sm text-gray-500 hover:text-lime-500 transition-colors">
                Gizlilik Politikası
              </Link>
              <Link to="#" className="text-sm text-gray-500 hover:text-lime-500 transition-colors">
                Kullanım Koşulları
              </Link>
              <Link to="#" className="text-sm text-gray-500 hover:text-lime-500 transition-colors">
                KVKK
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
